import { styled } from "@mui/system";
import { Modal as MuiModal } from "@mui/material";

const Modal = styled(MuiModal)(({ styles }) => ({
  ".MuiBackdrop-root": {
    backgroundColor: `var(--overlay-future-tax-60)`,
  },

  ".MuiBox-root": {
    backgroundColor: `var(--modal)`,
    // boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
    padding: "12px",
  },

  ...styles,
}));

export default Modal;
